import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component - handles scroll position on route changes
 * - Scrolls to top on pathname change (new page)
 * - Honors #hash anchors by scrolling to the target element
 * - Uses requestAnimationFrame for reliable scroll timing after render
 */
const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to ensure DOM is ready
    const scrollAction = () => {
      if (hash) {
        // If there's a hash, try to scroll to that element
        const targetId = hash.replace('#', '');
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // No hash - scroll to top of page
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      }
    };

    // Small delay to ensure page content is rendered
    // This fixes issues where scrollTo fires before new page renders
    const timeoutId = setTimeout(() => {
      requestAnimationFrame(scrollAction);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname, hash, key]);

  return null;
};

export default ScrollToTop;
